'use es6';

export const FILE_ID = ['fileId'];
export const FILE_METADATA = ['fileMetadata'];
export const FILE_USAGE_TYPE = ['fileUsageType'];
export const THUMBNAIL_METADATA = ['thumbnailMetadata'];